import React from 'react';
import { connect } from 'react-redux';

import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import { formatDayToYearLong } from 'utils/date/format.util';

import FutureRevenueProjectionsTable from 'reports/FutureRevenue/FutureRevenueProjectionsTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { convertStylistsMapsToStylistTableData } from 'reports/utils';
const ReportsProps = ['salonHoursReport', 'salesReport', 'uniqueVisitsReport', 'appointmentsReport'];

class FutureRevenueLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    let revenueData;
    const currencyAbbr = this.props.currency;

    if (this.checkIfAllDataIsLoaded()) {
      const stylistGroup = this.props.salesReport.lastRequestResponse.stylist_group;

      const nameServicesTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
      });
      const nameProductsTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      });

      revenueData = convertStylistsMapsToStylistTableData(
        nameServicesTotalPriceMap,
        nameProductsTotalPriceMap,
        currencyAbbr,
      );
    }

    return (
      <div className="has-protipbox">
        <div className="performance p3">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
              <div className="spinner-text">
                Loading LOTS of financial and booking data{' '}
                <span role="img" aria-labelledby="nerd face emoji">
                  🤓
                </span>
                <br />
                Please wait...
              </div>
            </div>
          )}
          {this.checkIfAllDataIsLoaded() && revenueData && (
            <React.Fragment>
              <div className="banner default full-width kpi">
                <div style={{ width: '100%' }}>
                  <div className="cfix relative">
                    <span className="img-emoji-1" role="img" aria-labelledby="lamp" style={{ marginTop: '-10px' }}>
                      💡
                    </span>
                    <div className="text">
                      <strong>Pro tip:</strong>
                      Select a future date range to see projections of your expected takings
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: '18px' }} />

              <FutureRevenueProjectionsTable
                startDate={formatDayToYearLong(this.props.uniqueVisitsReport.start_date)}
                endDate={formatDayToYearLong(this.props.uniqueVisitsReport.end_date)}
              />
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { reports } = state;
  const {
    salonHoursReport,
    salesReport,
    uniqueVisitsReport,
    uniqueClientsReport,
    appointmentsReport,
    stylistsRequestsReport,
  } = reports;
  const currency = selectCurrentSalonCurrency(state);
  return {
    salesReport,
    salonHoursReport,
    uniqueVisitsReport,
    uniqueClientsReport,
    appointmentsReport,
    stylistsRequestsReport,
    currency,
  };
}

export default connect(mapStateToProps, {})(FutureRevenueLayout);
